import type { Message } from "./Message";

const logMessage = (message: Message) => {
  switch (message.type) {
    case "COMMAND:CREATE_LEAD":
    case "COMMAND:CHANGE_URL":
    case "COMMAND:LOGIN_REDIRECT":
    case "COMMAND:CHANGE_DIRTY":
    case "COMMAND:NAV_CANCEL":
    case "COMMAND:NAV_PROCEED":
    case "COMMAND:SHOW_NAVIGATION_BLOCK":
    case "COMMAND:LOGOUT":
    case "COMMAND:MASQUERADE":
    case "COMMAND:UPDATE_TITLE":
    case "COMMAND:UPDATE_FAVICON":
    case "EVENT:AUTH_TOKEN":
    case "EVENT:BOOTSTRAP":
    case "EVENT:READY":
    case "EVENT:LOGIN_SUCCESS":
    case "QUERY:AUTH_TOKEN":
    case "COMMAND:SHOW_SNACKBAR":
    case "COMMAND:SET_RETAIL_STORE_LOCATION":
    case "EVENT:GET_PARENT_RETAIL_STORE_DATA":
      // eslint-disable-next-line no-console
      console.log(
        "📬",
        message.source,
        message.type,
        "payload" in message ? message.payload : undefined
      );
      break;
    default: {
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      const never: never = message;
    }
  }
};

export { logMessage };
